import { useCallback, useEffect, useState } from 'react';

export function useDebounce<T>(initial: T, delay: number) {
  const [debounced, setVal] = useState(initial);
  const [origin, setOrigin] = useState(initial);

  useEffect(() => {
    const timerId = setTimeout(() => {
      setVal(origin);
    }, delay);
    return () => {
      clearTimeout(timerId);
    };
  }, [origin, delay]);

  const setDebounce = useCallback((value: T) => {
    setOrigin(value);
  }, []);

  return {
    debounced,
    setDebounce,
    origin,
  };
}
